module.exports = __webpack_public_path__ + "static/media/CM.785c3bd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CM.svg
// module id = 226
// module chunks = 0